import * as LDClient from "launchdarkly-js-client-sdk";

import { CURRENT_ENV, env } from "~/env";

export type InitLDClient = LDClient.LDClient | null;

type LaunchDarklyUserContext = {
  anonymous?: boolean;
  email?: string;
  kind: "user";
  key: string;
  orgId?: string;
};

let ldClient: InitLDClient | null = null;

const getContextValue = (value?: string | null): string | null => {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
};

export const buildLDUserContext = ({
  userId,
  userEmail,
  orgId,
}: {
  orgId?: string | null;
  userEmail?: string | null;
  userId?: string | null;
}): LaunchDarklyUserContext => {
  const contextKey = getContextValue(userId);
  const email = getContextValue(userEmail);
  const normalizedOrgId = getContextValue(orgId);

  const context: LaunchDarklyUserContext = contextKey
    ? {
        kind: "user",
        key: contextKey,
      }
    : {
        anonymous: true,
        kind: "user",
        key: "anonymous",
      };

  if (email) {
    context.email = email;
  }

  if (normalizedOrgId) {
    context.orgId = normalizedOrgId;
  }

  return context;
};

export const initLDClient = async (userId: string, orgId?: string | null) => {
  if (!ldClient) {
    // Build complete context with both userId and orgId from the start
    // This ensures LaunchDarkly evaluates all flags against the correct context
    const context = buildLDUserContext({ userId, orgId });

    ldClient = LDClient.initialize(env.NEXT_PUBLIC_LAUNCHDARKLY_CLIENT_KEY, context, {
      application: {
        id: "erp-client",
        version: CURRENT_ENV,
      },
    });
  }
  await ldClient.waitForInitialization();
  return ldClient;
};
